import React from "react";

export const tooltipLangue = () => {
  return (
    <span>
      <b>Kurde (dialectes) :</b> <br />
      <b>Kurde Irak :</b> badini et sorani. <br />
      <b>Kurde Syrie :</b> badini et kurmanji. <br />
      <b>Kurde Turquie :</b> kurmanji. <br />
      <b>Kurde Iran :</b> sorani (ou langue farsi selon les régions). <br />
    </span>
  );
};
